export class ScriptsIds {
  public static GoogleMaps = "google-maps-script";
  public static Boardwalk = "boardwalk-script";
  public static Horizon = "horizon-script";
  public static ThreeDS = "three-ds-script";
  public static MXConnect = "mx-connect-script";
  public static BoardwalkV2 = "boardwalk-universal-script";
}
